const wsUrl = 'ws://localhost:1818'
const cbs = {}

const wsJoyusingInner = () => {
    var socket = undefined
    var closing = undefined
    var isReconnect = false
    var connected = false

    const onopen = e => {
        connected = true
        // console.log('on open:', e)
    }

    const onmessage = e => {
        //console.log('e',e)
        //执行回调
        if (cbs[e.data])
            cbs[e.data]()
        else if (e.data.indexOf('BeginsGetBase64') >= 0)
            cbs['getPhoto'](e.data.replace('BeginsGetBase64', '').replace('EndsGetBase64', ''))
        else
            cbs['updatePhoto'](e.data)
    }

    const onerror = e => {
        connected = false
        //reConnect()
        console.error('onerror:', e)
        alert("请确认拍照服务是否开启!")
    }

    const onclose = e => {
        connected = false
        socket = undefined

        // console.log('onclose:', e)

        if (closing) {
            closing = undefined
            return
        }

        reConnect()
        //console.log(e.data)
    }

    //初始化websocket连接 
    const initWs = () => {
        if (Tyan.appSettings.useMockData || !Tyan.appSettings.fileServerInfo.joyusingV1)
            return
        const webSocket = window.WebSocket || window.MozWebSocket
        if (!webSocket) {
            console.error('该浏览器不支持websocket')
            return
        }

        //Internet选项->安全->本地Internet->站点 没有添加的时候会报错，针对不安装控件的客户加了try
        try {
            socket = new WebSocket(wsUrl)
            socket.onopen = onopen
            socket.onmessage = onmessage
            socket.onclose = onclose
            socket.onerror = onerror
        } catch (e) { }
    }

    //重新连接
    const reConnect = () => {
        if (isReconnect) return
        isReconnect = true
        setTimeout(() => {
            initWs()
            isReconnect = false
        }, 5000)
    }

    const close = () => {
        socket && (closing = true, socket.close(), socket = null)
    }

    const sendMsg = obj => {
        // console.log('send msg:', obj, socket)
        socket && socket.send(obj)
    }

    const isConnected = () => {
        return connected
    }

    //初始化websocket连接    
    initWs()

    return { close, sendMsg, isConnected }
}

const wsJoyusing = (() => {
    let wsClient
    /**
     * 
     * @param {*} key : 可用类型:'start, updatePhoto', 
     * @param {*} cb 
     */
    const register = (key, cb) => {
        cbs[key] = cb
    }

    const unregister = (key, cb) => {
        cbs[key] && delete cbs[key]
    }

    const disConnect = () => { wsClient && (wsClient.close(), wsClient = undefined) }
    const sendMsg = obj => wsClient && wsClient.sendMsg(obj)
    const connect = (cb) => {
        disConnect()
        wsClient = wsJoyusingInner()
        waitForConnection(() => cb && cb(), 500)
    }
    const waitForConnection = (callback, interval) => {
        if (wsClient.isConnected())
            callback()
        else
            setTimeout(() => waitForConnection(callback, interval), interval)
    }

    return { connect, disConnect, sendMsg, register, unregister }
})()

export default wsJoyusing